import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { LearnCardPresentationId } from "@-/dev.improve.haniverse.lib.learn.card-action";

/**
 * Which PRESENTATION the surrounding card subtree belongs to, for claiming the deck's action area.
 *
 * Deliberately not read from deck state: a card that is being dismissed must still identify itself
 * as the presentation it always was, while `state.current` has already advanced to its successor.
 * Taking the owner from the nearest card instead is what lets a late release be recognised as
 * stale and dropped. Every card slot provides it; registering outside one is a programming error,
 * so the default throws.
 */
export const LearnCardControlsPresentationContext = createContext(
  defaultError<LearnCardPresentationId>("LearnCardControlsPresentationContext"),
);
